import Request from '../components/request/js/index.js';
export default {
  //获取套餐列表
  getFeeList(){
  	return Request().get('/fee/lists', {
  	  header: {
  	    contentType: 'application/json'
  	  },
  	  data: {
  	    
  	  }
  	});
  },
	//预购买套餐
	prePay(fee_id,type){
		return Request().post('/fee/pay/pre', {
		  header: {
		    contentType: 'application/json'
		  },
		  data: {
		    fee_id:fee_id,
				type:type,
		  }
		});
	},
	//套餐下单
	getOrderInfo(fee_id,type){
		return Request().post('/fee/pay/order', {
		  header: {
		    contentType: 'application/json'
		  },
		  data: {
		    fee_id:fee_id,
				type:type,
		  }
		});
	},
	//订单列表
	orderList(){
		return Request().get('/order/lists', {
		  header: {
		    contentType: 'application/json'
		  },
		  data: {
		    
		  }
		});
	},
	//同步奇乐云会员
	qiletvVip(){
		return Request().get('/auth/syncVipTime', {
		  header: {
		    contentType: 'application/json'
		  },
		  data: {
		    
		  }
		});
	},
};
